import { call, put, takeLatest } from 'redux-saga/effects';

import { history } from '@utils/history';
import { InsurancePolicy } from '@models/InsurancePolicy';
import { InsurancePolicyApi } from '@apis/InsurancePolicyApi';
import { InsurancePaymentTransaction } from '@models/InsurancePaymentTransaction';
import { SagaPayload } from '@utils/typescript';
import { routeInsurancePolicyBuyReviewPage } from './route';
import { InsuranceBilling } from '@models/InsuranceBilling';

import {
  insurancePolicyCreate,
  InsurancePolicyCreatePayload,
  insurancePolicyFetch,
  InsurancePolicyFetchPayload,
  insurancePolicyUpdate,
  InsurancePolicyUpdatePayload,
  insurancePolicyLock,
  InsurancePolicyLockPayload,
  insurancePolicyPay,
  InsurancePolicyPayPayload,
  insurancePolicyPayByCash,
  InsurancePolicyPayByCashPayload,
  billingFetch,
  BillingFetchPayload,
  stateUpdate,
  StateUpdatePayload,
} from './action';

function* handleInsurancePolicyCreate({ payload }: SagaPayload<InsurancePolicyCreatePayload>) {
  const state: StateUpdatePayload = { policy: null };
  try {
    state.policy = (yield call(InsurancePolicyApi.create, payload)) as InsurancePolicy;
    yield put(stateUpdate(state));
    history.navigate(routeInsurancePolicyBuyReviewPage({ insurancePolicyId: state.policy.id }));
  } catch { }
}

function* handleInsurancePolicyFetch({ payload }: SagaPayload<InsurancePolicyFetchPayload>) {
  const state: StateUpdatePayload = { policy: null };
  try {
    state.policy = (yield call(InsurancePolicyApi.get, payload)) as InsurancePolicy;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleInsurancePolicyUpdate({ payload }: SagaPayload<InsurancePolicyUpdatePayload>) {
  const state: StateUpdatePayload = { policy: null };
  try {
    state.policy = (yield call(InsurancePolicyApi.update, payload)) as InsurancePolicy;
    yield put(stateUpdate(state));
    history.navigate(routeInsurancePolicyBuyReviewPage({ insurancePolicyId: state.policy.id }));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleInsurancePolicyLock({ payload }: SagaPayload<InsurancePolicyLockPayload>) {
  const state: StateUpdatePayload = { policy: null };
  try {
    state.policy = (yield call(InsurancePolicyApi.lock, payload)) as InsurancePolicy;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleInsurancePolicyPay({ payload }: SagaPayload<InsurancePolicyPayPayload>) {
  const state: StateUpdatePayload = { paymentTransaction: null };
  try {
    state.paymentTransaction = (yield call(InsurancePolicyApi.pay, payload)) as InsurancePaymentTransaction;
  } catch {
    // handle error
  } finally {
    yield put(stateUpdate(state));
  }
}

function* handleInsurancePolicyPayByCash({ payload }: SagaPayload<InsurancePolicyPayByCashPayload>) {
  const state: StateUpdatePayload = { policy: null };
  try {
    state.policy = (yield call(InsurancePolicyApi.payByCash, payload)) as InsurancePolicy;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

function* handleBillingFetch({ payload }: SagaPayload<BillingFetchPayload>) {
  const state: StateUpdatePayload = { billing: null };
  try {
    state.billing = (yield call(InsurancePolicyApi.billing, payload)) as InsuranceBilling;
    yield put(stateUpdate(state));
  } catch {
    yield put(stateUpdate(state));
  }
}

export default function* () {
  yield takeLatest(insurancePolicyCreate, handleInsurancePolicyCreate);
  yield takeLatest(insurancePolicyFetch, handleInsurancePolicyFetch);
  yield takeLatest(insurancePolicyUpdate, handleInsurancePolicyUpdate);
  yield takeLatest(insurancePolicyLock, handleInsurancePolicyLock);
  yield takeLatest(insurancePolicyPay, handleInsurancePolicyPay);
  yield takeLatest(insurancePolicyPayByCash, handleInsurancePolicyPayByCash);
  yield takeLatest(billingFetch, handleBillingFetch);
}
